import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DataGrid } from '@mui/x-data-grid';
import axios from "axios";
import ReuseableButton from "../../../components/Buttons/button";
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import { userColumns } from "./deaprtmentColumns";

const departmentUrl = "https://arogyanxtdevapi.fundaclear.in/api/Department"

const DepartmentList = () => {
    const [loader, setLoader] = useState(false);
    const [departmentList, setDepartment] = useState([]);
    const navigate = useNavigate();


    useEffect(() => {
        const fetchDepartmentList= () => {
            setLoader(true)
            axios.get(departmentUrl).then((res) => {
                if (res?.status === 200) {
                    setLoader(false)
                    setDepartment(res?.data?.result)
                }

            }).catch(err => console.log(err))
        }
        fetchDepartmentList()
    }, [])
    const handleRouteBranchInfo = () => {
        navigate("/master/add-department")
    }
    const handleGetRowId = (e) => {
        return e?.uniqueId
    }
   
    return (
        <>
            <div className='d-flex justify-content-end'>
                <div className="mr-5">
                    <ReuseableButton
                        text={"Add Department"}
                        height={45}
                        colorVarient="success"
                        fullWidthFlag={true}
                        endIcon={<PersonAddAltIcon />}
                        handleChange={handleRouteBranchInfo}
                    />

                </div>
            </div>
            <div className="branch-table p-2">
                <DataGrid
                    autoHeight
                    rows={departmentList && departmentList?.length > 0 ? departmentList : []}
                    loading={loader ? loader : false}
                    columns={userColumns}
                    pageSize={10}
                    rowsPerPageOptions={[5]}
                    disableSelectionOnClick
                    experimentalFeatures={{ newEditingApi: true }}
                    getRowId={handleGetRowId}
                    checkboxSelection={false}
                />
            </div>
        </>
    )
};

export default DepartmentList